<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Basic Settings</h4>
          <el-form :model="From"  
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <h4>2.4G WIFI</h4>
             <el-form-item  v-for="(item,index) in list2g" :key="index" :label="item.name+':'" prop="">
                <el-select  placeholder="Please select" style="width: 100%" v-model="item.form" >
                    <el-option v-for="(item,index) in item.list" :key="index" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="MaxiMum clients" prop="maxiMum2g">
                <el-input v-model="From.maxiMum2g"></el-input>
            </el-form-item>
             <el-form-item label="Country:" prop="country2g" >
                <el-input v-model="From.country2g" disabled></el-input>
            </el-form-item>

             <h4>5G WIFI</h4>
             <el-form-item  v-for="(item,index) in list5g" :key="index" :label="item.name+':'" prop="">
                <el-select  placeholder="Please select" style="width: 100%" v-model="item.form" >
                    <el-option v-for="(item,index) in item.list" :key="index" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="MaxiMum clients" prop="maxiMum5g">
                <el-input v-model="From.maxiMum5g"></el-input>
            </el-form-item>
             <el-form-item label="Country:" prop="country5g" >
                <el-input v-model="From.country5g" disabled></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">Save</el-button>
            </el-form-item>


        </el-form>
    </div>
    
</template>

<script>
export default {
    data(){
       return {
            From:{
                maxiMum2g:"",
                country2g:"",
                maxiMum5g:"",
                country5g:"",
            },
            list2g:[{name:"2.4G WIFI Channel",form:"Auto",list:[{name:"Auto",value:0},{name:"1",value:1},{name:"2",value:2},{name:"3",value:3},{name:"4",value:4},{name:"5",value:5},{name:"6",value:6},{name:"7",value:7},{name:"8",value:8},{name:"9",value:9},{name:"10",value:10},{name:"11",value:11}]},

            {name:"Mode",form:"",list:[{name:"802.11b",value:1},{name:"802.11g",value:2},{name:"802.11b/g",value:3},{name:"802.11b/g/n",value:11}]},

            {name:"Bandwidth",form:"",list:[{name:"20MHz",value:0},{name:"40MHz",value:1},{name:"20/40MHz",value:2}]},

            {name:"11n Interval Setting",form:"",list:[{name:"Long interval",value:0},{name:"Short interval",value:1}]},

            {name:"Hide SSID",form:"",list:[{name:"Close",value:0},{name:"Open",value:1}]},

            {name:"WMM",form:"",list:[{name:"Close",value:0},{name:"Open",value:1}]}],

            list5g:[{name:"2.4G WIFI Channel",form:"",list:[{name:"Auto",value:0},{name:"1",value:1},{name:"2",value:2},{name:"3",value:3},{name:"4",value:4},{name:"5",value:5},{name:"6",value:6},{name:"7",value:7},{name:"8",value:8},{name:"9",value:9},{name:"10",value:10},{name:"11",value:11}]},

            {name:"Mode",form:"",list:[{name:"802.11b",value:1},{name:"802.11g",value:2},{name:"802.11b/g",value:3},{name:"802.11b/g/n",value:11}]},

            {name:"Bandwidth",form:"",list:[{name:"20MHz",value:0},{name:"40MHz",value:1},{name:"20/40MHz",value:2}]},

            {name:"11n Interval Setting",form:"",list:[{name:"Long interval",value:0},{name:"Short interval",value:1}]},

            {name:"Hide SSID",form:"",list:[{name:"Close",value:0},{name:"Open",value:1}]},

            {name:"WMM",form:"",list:[{name:"Close",value:0},{name:"Open",value:1}]}],
       }
    },
    methods:{
       ftpDownload(){

       }
    },
}
</script>





